import api from 'api/api'

import { toast } from "react-toastify"
import { API_URL } from 'constants/index'

export const GET_LIST_DRIVERS = "[MANAGEMENT DRIVER] GET LIST DRIVERS"

export const SAVE_DRIVER = "[MANAGEMENT DRIVER] SAVE DRIVER"

export const UPDATE_DRIVER = "[MANAGEMENT DRIVER] UPDATE DRIVER"

export const DELETE_DRIVER = "[MANAGEMENT DRIVER] DELETE DRIVER"


export function getManagementDriver() {
  const request = api.get(`/transportista`)
  return (dispatch) =>
    request.then((response) => {
      return dispatch({
        type: GET_LIST_DRIVERS,
        payload: response.data.detalles === null ? [] : response.data.detalles,
      })
    })
}

export function saveManagementDriver(form) {
  const request = api.post(`/rtransportista`, form)
  return (dispatch) => {
    dispatch({ type: SAVE_DRIVER, payload: { loading: true, saved: false, data: null } })
    toast.info("Guardando datos...", { toastId: "infoDriver", autoClose: false })
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        toast.update("infoDriver", { render: response.data.message, type: "success", autoClose: 3000 })
        dispatch({ type: SAVE_DRIVER, payload: { loading: false, saved: true, data: response.data.detalles } })
      } else {
        toast.update("infoDriver", { render: response.data.message, type: "error", autoClose: 5000 })
      }
      setTimeout(() => {
        dispatch({ type: SAVE_DRIVER, payload: { loading: false, saved: false, data: null } })
      }, 50)
    }).catch((err => {
      dispatch({ type: SAVE_DRIVER, payload: { loading: false, saved: false, data: null } })
      console.log(err)
      toast.update("infoDriver", { autoClose: 5000, type: "error" })
    }))
  }
}

export function updateManagementDriver(form) {
  const request = api.post(`/atransportista`, form)
  return (dispatch) => {
    dispatch({ type: UPDATE_DRIVER, payload: { loading: true, updated: false } })
    toast.info("Actualizando datos...", { toastId: "infoDriver", autoClose: false })
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        toast.update("infoDriver", { render: response.data.message, type: "success", autoClose: 3000 })
        dispatch({ type: UPDATE_DRIVER, payload: { loading: false, updated: true } })
      } else {
        toast.update("infoDriver", { render: response.data.message, type: "error", autoClose: 5000 })
      }
      setTimeout(() => {
        dispatch({ type: UPDATE_DRIVER, payload: { loading: false, updated: false } })
      }, 50)
    }).catch((err => {
      dispatch({ type: UPDATE_DRIVER, payload: { loading: false, updated: false } })
      console.log(err)
      toast.update("infoDriver", { autoClose: 5000, type: "error" })
    }))
  }
}

export function deleteManagementDriver(form) {
  const request = api.get(`/etransportista/${form.idtransportista}`, form)
  return (dispatch) => {
    request.then((response) => {
      toast.info("Eliminando datos...", { toastId: "infoDriver", autoClose: false })
      if (parseInt(response.data.status) === 200) {
        toast.update("infoDriver", { render: response.data.message, type: "success", autoClose: 3000 })
        dispatch({ type: DELETE_DRIVER, payload: true })
      } else {
        toast.update("infoDriver", { render: response.data.message, type: "error", autoClose: 5000 })
      }
      setTimeout(() => {
        dispatch({ type: DELETE_DRIVER, payload: false })
      }, 50)
    }).catch((err => {
      dispatch({ type: DELETE_DRIVER, payload: false })
      console.log(err)
      toast.update("infoDriver", { autoClose: 5000, type: "error" })
    }))
  }
}
